import type { App } from 'vue'
import Toast from 'vue-toastification'
import type { PluginOptions } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import WarningCircleFill from '@/assets/icons/warning-circle-fill.svg'
import CheckCircle from '@/assets/icons/check-circle.svg'

const toastOptions: PluginOptions = {
	timeout: 3000,
	filterBeforeCreate: (currentToast, toasts) => {
		if (toasts.find((toast) => toast.content === currentToast.content)) {
			// discard the toast if we're already showing one with the same content
			return false
		}

		// toast passed
		return currentToast
	},
	toastDefaults: {
		error: {
			toastClassName: 'bg-red! text-white!',
			icon: WarningCircleFill
		},
		success: {
			toastClassName: 'bg-green! text-white!',
			icon: CheckCircle
		}
	}
}

export default {
	install (app: App) {
		app.use(Toast, toastOptions)
	}
}
